import { Component, Inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EnvironmentService } from '../environment/environment.service';
import { Apollo } from 'apollo-angular';
import { login } from '../auth/graphql/login';
import { Subscription } from 'rxjs';
import { AlertService } from '../alert/alert.service';
import { CurrentUserService } from '../services/current-user.service';


const LOGIN = login;

@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent {
  logging_in = false;

  constructor(
    public authService: AuthService,
    public environment: EnvironmentService,
    public alertService: AlertService,
    public userService: CurrentUserService,
    public apollo: Apollo,
    public router: Router,
    public dialog: MatDialog,
    public document: Document
  ) {
    if (localStorage.getItem('auth_code')) {
      this.logging_in = true;
      this.login();
    }
  }

  querySubscription: Subscription;

  ssoRedirect() {
    const ssourl = this.document.location.origin;
    let ssoUrl =
      'https://login.microsoftonline.com/91d5341e-e81c-43b7-bdfa-d865952d2de4/oauth2/v2.0/authorize?response_type=code&scope=openid%20profile%20offline_access%20Sites.ReadWrite.All&client_id=1c19998a-4749-4229-9583-4d40dc81a8db&redirect_uri=' +
      encodeURIComponent(ssourl) +
      '&prompt=select_account&response_mode=fragment&sso_reload=true&code_challenge=3tTzVpqnEpFa6DJa4kHYeNzaWHq3255KxTWSkfxFY2pMfUavgd';

    this.document.location.assign(ssoUrl);
  }

  login() {
    this.apollo
      .mutate<any>({
        mutation: LOGIN,
        variables: {
          authorization_code: localStorage.getItem('auth_code'),
        },
      })
      .subscribe(
        ({ data }) => {
          localStorage.removeItem('auth_code');
          this.authService.login(data);
          if (this.authService.isLoggedIn()) {
            this.userService.updateCurrentUserInToken();
            let redirectTo = localStorage.getItem('redirectTo');
            if (redirectTo) {
              localStorage.removeItem('redirectTo');
              this.router.navigate([redirectTo]);
            } else {
              this.router.navigate(['/main']);
            }
          } else {
            this.router.navigate(['/login']);
          }
        },
        (error) => {
          this.alertService.add(
            'auth',
            'An unknown error occurred while attempting to log in.'
          );
          localStorage.removeItem('auth_code');
          this.logging_in = false;

          this.router.navigate(['/login']);
        }
      );
  }

  logout() {
    this.authService.logout();
  }
}

